import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DateDiv } from './styles';

export const NewDatePicker = ({ themeColor, dueDate, setDueDate }) => {
  return (
    <DateDiv themeColor={themeColor}>
      <DatePicker
        selected={dueDate}
        onChange={(date) => setDueDate(date)}
        inline
      />
    </DateDiv>
  );
};
